import { AgencyStates } from '../type-aliases/agency-states';

export const activeAgencyStates: AgencyStates[] = ['trial', 'active', 'late'];
